import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/api.service';
import { ShareService } from 'src/app/services/share.service';
import { Clipboard } from '@angular/cdk/clipboard';
@Component({
  selector: 'app-share-popup',
  templateUrl: './share-popup.component.html',
  styleUrls: ['./share-popup.component.scss']
})
export class SharePopupComponent implements OnInit{
  isCopyed=false;
  constructor(public _as:AppService,public _share:ShareService,private location:Location,private clipboard: Clipboard){}

  ngOnInit(): void {
    console.log(this._share.share_link);
  }

  copyLink(){
      navigator.clipboard.writeText(this._share.share_link)
      this.isCopyed = true;
      setTimeout(() => {
        this.isCopyed = false;
      }, 3000);
    // }
  }
}

